/* eslint-disable no-nested-ternary */
import CardWithTitle from 'components/CardWithTitle';
import React from 'react';
import { Col, Label, Row } from 'reactstrap';
import { NumberWithCommasFormat } from 'utils/constants';
import InfoCard from 'components/InfoCard';
import BidsInfoDetail from '../BidsInfoDetail';
import OrderInfoDetail from '../OrderInfoDetail';
import ProductInfoDetail from '../ProductInfoDetail';
import FavouritedUsersDetail from '../FavouritedUsersDetail';

const LiveOfferDetails = ({ row, type }) => {
  const {
    createdAt,
    acceptedBids,
    rejectedBids,
    totalOrders,
    deliveredOrders,
  } = row;
  const gradeId = row?.grade?.id || row?.grades?.[0]?.id;
  return (
    <Row>
      <Col sm={9}>
        <InfoCard
          offerId={row?.id}
          gradeName={
            row?.grade
              ? row?.grade?.name
              : row?.grades.length
                ? row?.grades[0]?.name
                : '-'
          }
          category={
            row?.grade
              ? row.grade.category?.name
              : row?.grades.length
                ? row?.grades[0]?.name
                : '-'
          }
          rate={`$${row?.rate}`}
          createDate={createdAt}
          validity={row?.validityInHours}
        />

        <CardWithTitle title="Other Details">
          <div className="order-status border rounded-8 p-3 mt-2 mb-3">
            <Row className="mb-2">
              <Col sm={4}>
                <Label className="f-12 fw-medium">Offer Type</Label>
              </Col>
              <Col sm={8}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  {row[type]}
                </span>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col sm={4}>
                <Label className="f-12 fw-medium">Packaging type</Label>
              </Col>
              <Col sm={8}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  {row?.packagingTypeId?.type}
                  {row?.packagingType?.type}
                </span>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col sm={4}>
                <Label className="f-12 fw-medium">Minimum order quantity</Label>
              </Col>
              <Col sm={8}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  {NumberWithCommasFormat(row?.minimumQty)}
                </span>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col sm={4}>
                <Label className="f-12 fw-medium">Total quantity</Label>
              </Col>
              <Col sm={8}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  {NumberWithCommasFormat(row?.totalQty)}
                </span>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col sm={4}>
                <Label className="f-12 fw-medium">Location</Label>
              </Col>
              <Col sm={8}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  {row?.state?.stateName}
                </span>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <Label className="f-12 fw-medium">Source</Label>
              </Col>
              <Col sm={8}>
                <span className="font-manrope text-gray f-12 fw-semibold d-block">
                  -
                </span>
              </Col>
            </Row>
          </div>
        </CardWithTitle>

        <BidsInfoDetail
          row={row}
          acceptedBids={acceptedBids}
          rejectedBids={rejectedBids}
        />
        <OrderInfoDetail
          deliveredOrders={deliveredOrders}
          totalOrders={totalOrders}
        />
        <FavouritedUsersDetail gradeId={gradeId} />
      </Col>

      <Col sm={3}>
        <ProductInfoDetail
          row={row}
          sellerName={`${row?.trader?.firstName} ${row?.trader?.lastName}`}
          name={row?.grade?.name}
          offerType={row?.offerType}
          type={type}
        />
      </Col>
    </Row>
  );
};

export default LiveOfferDetails;
